import { useFela } from 'react-fela';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import Card from 'antd/lib/card';
import Spin from 'antd/lib/spin';
import { FormattedMessage } from 'react-intl';

import { DetailButton, CopyButton } from 'modules/layout';
import { filePropTypes, utils as uploaderUtils, constants as uploaderConstants } from 'modules/uploader';

import rule from './Image.rule';

import DeleteImage from '../../containers/DeleteImage';

const options = {
    width: 206,
    height: 103,
};

const Image = ({ uid, status, firestoreId, url }) => {
    const cover = <img src={uploaderUtils.buildSource(uid, options)} alt="" />;
    const actions = [
        url && <DetailButton url={url} />,
        <CopyButton id={uid} />,
        firestoreId && <DeleteImage id={firestoreId} />,
    ].filter(Boolean);

    const { css } = useFela();

    return (
        <div className={classnames('Image', css(rule))}>
            {status === uploaderConstants.status.DONE && (
                <Card cover={cover} actions={actions}>
                    <Card.Meta title={uid} />
                </Card>
            )}
            {status === uploaderConstants.status.UPLOADING && (
                <Spin tip={<FormattedMessage id="maps.imageMap.status.uploading" />} />
            )}
        </div>
    );
};

Image.propTypes = {
    ...filePropTypes,
    firestoreId: PropTypes.string,
};

Image.defaultProps = {
    firestoreId: null,
};

export default Image;
